// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"bed95b40","182":"8031634e","183":"f74a8af8","453":"567ecfd5","640":"1805bfcf"}[chunkId] + ".chunk.js";
};